/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { Carousel, Image, Spin } from 'antd';
import AuthApi from 'apis/AuthApi';
import { background, logo_pnj_logIn, logo_pnj_2 } from 'assets/images';
import { useUser } from 'contexts/User';
import queryString from 'query-string';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router';
import { openNotificationWithIcon } from 'utils/notification';
import { getLogoutUri } from '../utils/getLogouURI';

const onboards = [
  {
    title: 'Ứng dụng PNJ PMS',
    sologan:
      'Ứng dụng quản lý đặt hàng, theo dõi, bày bán sản phẩm tại cửa hàng...',
  },
  {
    title: 'Ứng dụng PNJ PMS',
    sologan: 'Tối đa thời gian đặt hàng của cửa hàng và chi nhánh',
  },
  {
    title: 'Ứng dụng PNJ PMS',
    sologan: 'Nhanh chóng phản hồi các thay đổi sản phẩm',
  },
];

const SignInPage = (): JSX.Element => {
  const { getUser } = useUser();

  const history = useHistory();

  const query: any = queryString.parse(window.location.search);

  const code = query.code;

  const { mutate: signin, isLoading } = useMutation(AuthApi.signIn, {
    onSuccess: (data) => {
      localStorage.setItem('token', data.token);
      history.push('/');
      getUser();
    },
    onError: (error: any) => {
      openNotificationWithIcon(
        'error',
        'Bạn không có quyền đăng nhập vào hệ thống, vui lòng liên hệ quản trị viên'
      );
      // openNotificationWithIcon('error', error.response.data.message[0]);
      // history.push('/');
      // localStorage.removeItem('token');
      // const logout_uri = getLogoutUri();
      // window.location.replace(logout_uri);

      setTimeout(() => {
        history.push('/');
        localStorage.removeItem('token');
        const logout_uri = getLogoutUri();
        window.location.replace(logout_uri);
      }, 3000);
    },
  });

  const renderOnboard = (
    onboard: Array<{ title: string; sologan: string }>
  ) => {
    return onboard.map((onboard, index) => (
      <div key={index}>
        <p className="p-4 text-center text-white para-bold-1">
          {onboard.title}
        </p>
        <p className="p-2 text-center text-white para-2">{onboard.sologan}</p>
      </div>
    ));
  };

  useEffect(() => {
    if (!code) return;
    signin(code);
  }, [code]);

  const onSubmit = async () => {
    window.location.replace(process.env.REACT_APP_AWS_COGNITO_LOGIN as string);
  };
  const screenWidth = window.innerWidth;

  return (
    <Spin tip="Loading..." size="large" spinning={isLoading}>
      <div className="flex h-screen">
        <div
          className={
            screenWidth <= 768
              ? 'flex flex-col items-center justify-center w-full h-full'
              : 'flex flex-col items-center justify-center w-1/2 h-full'
          }
        >
          <Image
            width={100}
            height={100}
            src={logo_pnj_logIn}
            alt="logo"
            preview={false}
          />
          <button
            className="py-3 mt-12 font-bold text-white bg-primary-50 px-32 rounded-xl"
            onClick={onSubmit}
          >
            Đăng nhập
          </button>
          <p className="mt-3 ">
            <span className="mr-1 para-2 text-primary-30">
              Bạn cần hỗ trợ thông tin?
            </span>
            <span className="text-secondary-40 para-bold-2">Nhấn vào đây</span>
          </p>
        </div>
        <div
          style={{
            backgroundImage: `url(${background})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
          className={
            screenWidth <= 768
              ? 'hidden'
              : 'flex flex-col items-center justify-center w-1/2 h-full'
          }
        >
          <Image
            src={logo_pnj_2}
            alt="materials"
            preview={false}
            className="mb-5"
            width={300}
            height={300}
          />
          <div className="w-full">
            <Carousel autoplay={true} dots={false}>
              {onboards.map((onboard, index) => (
                <div key={index} className="flex flex-col gap-6 px-4">
                  <p
                    style={{
                      fontSize: '32px',
                      fontStyle: 'normal',
                      fontWeight: '700',
                      lineHeight: '60px',
                    }}
                    className="p-4 text-center text-white para-bold-1"
                  >
                    {onboard.title}
                  </p>
                  <p
                    style={{
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: '140%',
                      wordWrap: 'break-word',
                    }}
                    className="text-center text-white whitespace-pre opacity-70 text-wrap"
                  >
                    {onboard.sologan}
                  </p>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default SignInPage;
